import { localizedText } from '../../common-js/LanguageMap';

/* eslint-disable no-param-reassign */
export default function ($scope, $state, $log, $timeout, $window, DrawpService) {
    $scope.localizedText = localizedText;
    const progressText = $scope.localizedText('LOADING');
    $scope.progress = progressText;

    $scope.aboutDfsLogoSrc = 'https://drawpforschool.com/wp-content/themes/dfs/images/logo_drawpforschool_full.svg';

    $scope.stateTitle = 'Add-On Tools';
    $scope.userType = null;

    $scope.serverToken = '';
    $scope.userEmail = '';

    const showProgress = (show, message) => {
        $timeout(() => {
            $scope.error = null;
            $scope.progress = null;
            if (show) {
                $scope.progress = message;
            }
        });
    };

    $scope.goToVPMathJournalsPage = () => {
        $state.go('vpMathJournals');
    };

    $scope.goToGraphicOrganizers = () => {
        $state.go('graphicOrganizers');
    };

    $scope.goToSlideTranslation = () => {
        $state.go('slideTranslation');
    };

    $scope.goTo3lvl = () => {
        $state.go('scaffoldingLevel3');
    };

    $scope.goTo4lvl = () => {
        $state.go('scaffoldingLevel4');
    };

    $scope.goTo6lvl = () => {
        $state.go('scaffoldingLevel6');
    };

    $scope.goToAbout = () => {
        $state.go('about');
    };

    let menu = null;

    angular.element(document).ready(() => {
        showProgress(false, progressText);

        $timeout(() => {
            $scope.serverToken = localStorage.getItem('drawp-serverToken') != null ? localStorage.getItem('drawp-serverToken') : '';
            $scope.userEmail = localStorage.getItem('drawp-userEmail') != null ? localStorage.getItem('drawp-userEmail') : '';

            if ($scope.userEmail != '') document.getElementById("userEmail").innerText = $scope.userEmail;
            if ($scope.serverToken != '') document.getElementById("serverToken").innerText = $scope.serverToken;

            $scope.initMenu();
        });

        $scope.$on('ACCOUNT_CHANGE', () => {
            // console.log('ACCOUNT_CHANGE');
            $timeout(() => {
                $scope.serverToken = localStorage.getItem('drawp-serverToken') != null ? localStorage.getItem('drawp-serverToken') : '';
                $scope.userEmail = localStorage.getItem('drawp-userEmail') != null ? localStorage.getItem('drawp-userEmail') : '';
                $scope.$apply();
            });
        });

    });

    $scope.initMenu = () => {
        const menuElement = document.querySelector('#account-menu');
        const extMenuElement = document.querySelector('#account-menu-button');
        menu = new mdc.menu.MDCMenu(menuElement);
        menu.setAnchorElement(extMenuElement);
    };

    $scope.toggleMenu = ($event) => {
        console.log('toggleMenu');
        if (!menu) {
            $scope.initMenu();
        }
        const button = $event.currentTarget;
        console.log($event.currentTarget);
        menu.setAnchorElement(button);
        menu.open = !menu.open;
    };

    $scope.textBoxContent = "";
    $scope.addTextBox = function () {
        if (!$scope.textBoxContent.trim()) {
            return;
        }

        try {
            /**
           * Insert your PowerPoint code here
           */
            const options = { coercionType: Office.CoercionType.Text };

            Office.context.document.setSelectedDataAsync($scope.textBoxContent, options);
        } catch (error) {
            console.info(error);
        }
    };

    $scope.goToLogin = function () {
        DrawpService.openLoginDialog();
    };

    $scope.goToSubscriptions = function () {
        $state.go('activeSubscriptionsList');
    };

    $scope.logOut = function () {
        DrawpService.logOut();
        $state.go($state.current.name, {}, { reload: true });
    };

    $scope.getDisplayEmail = function (email) {
        if (!email) return '';
        const atIdx = email.indexOf('@');
        if (atIdx === -1) return email.length > 13 ? email.slice(0, 10) + '...' : email;

        let name = email.slice(0, atIdx);
        let domain = email.slice(atIdx + 1);

        if (domain.length > 10) {
            // Truncate name to 6 chars, add '...', then add last 10 chars of domain
            name = name.slice(0, 6) + '...';
            return name + domain;
        }
        if (name.length > 20) return name.slice(0, 10) + '...' + '@' + domain;
        return name + '@' + domain;
    };
}